import Vue from 'vue';
import { CALLATTRIBUTE_PAGE_LOAD_ACTION, UPDATE_CAMPAIGN_CALLATTRIBUTE_PAGE_ACTION, SCHEDULER_ADD_REMOVE_INTERVALS_ACTION, SCHEDULER_STATUS_CHANGED_ACTION, 
    SCHEDULER_ADD_DAY_PART_AND_INTERVALS_ACTION, SCHEDULER_REMOVE_DAY_PART_AND_INTERVALS_ACTION, SCHEDULER_USE_INTERVALS_CHANGED_ACTION,
    SCHEDULER_RESET_INTERVALS_ACTION,  SCHEDULER_INTERVAL_SETTING_CHANGED_ACTION, SCHEDULER_DATA_CHANGED_ACTION, LOAD_ACTIVE_DAY_PART_INTERVAL_ACTION,
    SCHEDULET_GET_INTERVAL_ACTION} from '../action-types'
import { SCHEDULER_START_TIME_CHANGED_MUTATION, SCHEDULER_END_TIME_CHANGED_MUTATION, SCHEDULER_DAY_PART_CAP_LIMIT_CHANGED_MUTATION,
    SCHEDULER_CONCURRENCY_CAP_CHANGED_MUTATION, SCHEDULER_MONTHLY_CAP_CHANGED_MUTATION, SCHEDULER_LOAD_SCHEDULE_MUTATION,
    SCHEDULER_ADD_DAY_PART_MUTATION, SCHEDULER_REMOVE_DAY_PART_MUTATION, SCHEDULER_ADD_INTERVALS_MUTATION,
    SCHEDULER_REMOVE_INTERVALS_MUTATION, SCHEDULER_WEEKDAY_STATUS_CHANGED_MUTATION, SCHEDULER_DAY_PART_STATUS_CHANGED_MUTATION,
    SCHEDULER_INTERVAL_STATUS_CHANGED_MUTATION, SCHEDULER_SET_ACTIVE_TAB_MUTATION, SCHEDULER_USE_INTERVALS_CHANGED_MUTATION,
    SCHEDULER_INTERVAL_SETTING_CHANGED_MUTATION, SCHEDULER_CLEAR_INTERVAL_CAPS_MUTATION, SCHEDULER_CHANGE_INTERVAL_LOADING_MUTATION,
    SCHEDULER_CLONE_MUTATION, SCHEDULER_HANDS_ON_TABLE_DATA_MUTATION, SCHEDULER_SOURCE_DATA_MUTATION, LOAD_ACTIVE_DAY_PART_INTERVAL_MUTATION,
     SCHEDULER_INTERVAL_MODIFIED_MUTATION,  SCHEDULER_UPDATE_INTERVAL_DATA_MUTATION, SCHEDULER_LOAD_OLD_DATA_MUTATION,
     SCHEDULER_CLEAR_OLD_DATA_MUTATION} from '../mutation-types';
import campaignService from '../../services/api/Campaigns';
import appConstants from '../../utility/app-constants';
export const namespaced = true;

// initial state
export const state = {
    scheduleData: loadEmptyScheduleData(0),
    campaignIntervalCapsData : null,
    activeTab: 1,
    isIntervalLoading: false,
    intervalData:[
        {weekDayValue:15, defaultIntervalValue:15,weekDay:'15 Mins',isDisabled:false, isSelected : false},
        {weekDayValue:30,defaultIntervalValue:30,weekDay:'30 Mins',isDisabled:false, isSelected : false},
        {weekDayValue:45,defaultIntervalValue:60,weekDay:'Hourly',isDisabled:false, isSelected : false}
    ],
    isIntervalModified:true,
    oldScheduleData:{}
};

// mutations
export const mutations = {
    [SCHEDULER_LOAD_OLD_DATA_MUTATION](state, scheduleData) {
        scheduleData.campaignDailySchedules.forEach( r => { 
            var DayPartId = 0;
            r.campaignDayPartSchedules.forEach( row => {
                DayPartId = row.DayPartId = DayPartId + 1;
            })
        })
        state.oldScheduleData = JSON.parse(JSON.stringify(scheduleData));
    },
    [SCHEDULER_LOAD_SCHEDULE_MUTATION](state, scheduleData) {
        state.activeTab = 1;
        Vue.set(state, 'scheduleData', scheduleData);
    },
    [SCHEDULER_START_TIME_CHANGED_MUTATION](state, payLoad) {
        payLoad.campaignDayPart.startMinute = parseInt(payLoad.campaignDayPart.startMinute) + payLoad.differenceOfMinutes;
    },
    [SCHEDULER_END_TIME_CHANGED_MUTATION](state, payLoad) {
        payLoad.campaignDayPart.endMinute = parseInt(payLoad.campaignDayPart.endMinute) + payLoad.differenceOfMinutes;
    },
    [SCHEDULER_DAY_PART_CAP_LIMIT_CHANGED_MUTATION](state, payLoad) {
        payLoad.campaignDayPart.capLimit = payLoad.capLimit;
    },
    [SCHEDULER_CONCURRENCY_CAP_CHANGED_MUTATION](state, payLoad) {
        payLoad.campaignDayPart.concurrencyCap = payLoad.concurrencyCap;
    },
    [SCHEDULER_WEEKDAY_STATUS_CHANGED_MUTATION](state, payLoad) {
        payLoad.campaignDailySchedule.status = payLoad.status;
    },
    [SCHEDULER_DAY_PART_STATUS_CHANGED_MUTATION](state, payLoad) {
        payLoad.campaignDailySchedule.campaignDayPartSchedules.map(row => row.status = payLoad.status);
    },
    [SCHEDULER_INTERVAL_STATUS_CHANGED_MUTATION](state, payLoad) {
        if (state.scheduleData.campaignIntervalCaps)
            state.scheduleData.campaignIntervalCaps.map(row => {
                if (row.dayOfWeek == payLoad.campaignDailySchedule.dayOfWeek) {
                    row.status = (String(state.scheduleData.useIntervals) == 'true' && payLoad.status == 'Active') ? 'Active' : 'InActive';
                    row.capLimit = row.status == 'Active' ? row.capLimit : '';
                }
            });
    },
    [SCHEDULER_MONTHLY_CAP_CHANGED_MUTATION](state, monthlyCap) {
        state.scheduleData.monthlyCap = monthlyCap;
    },
    [SCHEDULER_ADD_DAY_PART_MUTATION](state, payLoad) {
        payLoad.campaignDayPartSchedules.push(getEmptyDayPart(payLoad.campaignDayPart));
    },
    [SCHEDULER_REMOVE_DAY_PART_MUTATION](state, payLoad) {
        payLoad.campaignDayPartSchedules.splice(payLoad.dayPartItemIndex, 1);
    },
    [SCHEDULER_REMOVE_INTERVALS_MUTATION](state, payLoad) {
        state.scheduleData.campaignIntervalCaps = state.scheduleData.campaignIntervalCaps
        .filter(row => !(row.dayOfWeek == payLoad.dayOfWeek && row.dayPartItemIndex == payLoad.dayPartItemIndex));
    },
    [SCHEDULER_ADD_INTERVALS_MUTATION](state, intervals) {
        state.scheduleData.campaignIntervalCaps = state.scheduleData.campaignIntervalCaps.concat(intervals);
    },
    [LOAD_ACTIVE_DAY_PART_INTERVAL_MUTATION](state, intervals) {
        if(intervals.length > 0){
            var formCapLimitTiming = intervals.filter(row => !state.scheduleData.campaignIntervalCaps.some(r => r.startMinute == row.startMinute && 
            r.endMinute == row.endMinute && r.status == "Active" &&  row.status == "Active"  && r.dayOfWeek == row.dayOfWeek ))
            state.scheduleData.campaignIntervalCaps = state.scheduleData.campaignIntervalCaps.concat(formCapLimitTiming);
        }
    },
    [SCHEDULER_SET_ACTIVE_TAB_MUTATION](state, activeTab) {
        state.activeTab = activeTab;
    },
    [SCHEDULER_USE_INTERVALS_CHANGED_MUTATION](state, useIntervals) {
        state.scheduleData.useIntervals = useIntervals;
    },
    [SCHEDULER_INTERVAL_SETTING_CHANGED_MUTATION](state, intervalSetting) {
        state.scheduleData.intervalSetting = intervalSetting > 30 ? 60 : intervalSetting;
        state.intervalData.forEach(element=>{
            element.isSelected = false;
           if(element.weekDayValue == intervalSetting){
                element.isSelected = true;
           }
       });
       
    },
    [SCHEDULER_CLEAR_INTERVAL_CAPS_MUTATION](state) {
        state.scheduleData.campaignIntervalCaps = [];
    },
    [SCHEDULER_CHANGE_INTERVAL_LOADING_MUTATION](state, isIntervalLoading) {
        state.isIntervalLoading = isIntervalLoading;
    },
    [SCHEDULER_CLONE_MUTATION](state, clonedCampaignID) {
        state.scheduleData.campaignID = clonedCampaignID;
        state.scheduleData.campaignDailySchedules.map(row=> {
            row.campaignDayPartSchedules.map(dayPart=> dayPart.scheduleCapID = 0);
        });
        state.scheduleData.campaignIntervalCaps.map(row=> row.scheduleCapID = 0);
    },
    [SCHEDULER_HANDS_ON_TABLE_DATA_MUTATION](state, campaignIntervalCapsData) {
        state.campaignIntervalCapsData = campaignIntervalCapsData;
    },
    [SCHEDULER_SOURCE_DATA_MUTATION](state, payLoad) {
        let sourceData = state.scheduleData.campaignIntervalCaps;
        let weekdayObj =  payLoad.weekdayObj;
        let capLimit =  payLoad.capLimit;
        let filteredArray =  sourceData.filter(row =>  row.startMinute == weekdayObj.startMinute 
            && row.endMinute == weekdayObj.endMinute && row.dayOfWeek == weekdayObj.dayOfWeek);
        if(filteredArray && filteredArray.length > 0) {
            filteredArray[0].capLimit = capLimit;
        }
    },
    [SCHEDULER_INTERVAL_MODIFIED_MUTATION](state,isValue){
        state.isIntervalModified = isValue;
    },
    [SCHEDULER_UPDATE_INTERVAL_DATA_MUTATION](state, modifiedIntervalData)
    {
        if(modifiedIntervalData && modifiedIntervalData.length > 0) 
            state.intervalData = modifiedIntervalData;
        else{
            state.intervalData =  updateIntervalData(state.intervalData,state.scheduleData.intervalSetting);
            var intervals = state.intervalData.filter(x=>!x.isDisabled && x.isSelected);
            state.scheduleData.intervalSetting = intervals.length > 0 ? intervals[0].defaultIntervalValue : state.scheduleData.intervalSetting;
        }
    },
    [SCHEDULER_CLEAR_OLD_DATA_MUTATION](state){
        state.oldScheduleData = {}
    }
};

// actions
export const actions = {
    [SCHEDULER_DATA_CHANGED_ACTION]({ commit }, payLoad) {
        //[[6,"2",15,15],[7,"2",15,15]] //[[rownumber, weekday, oldvalue, changedValue],[]]
        commit(SCHEDULER_HANDS_ON_TABLE_DATA_MUTATION, payLoad.handsOnTableDataSource);
        let modifiedScheduledDatas = payLoad.changedDatas;
        if(modifiedScheduledDatas && modifiedScheduledDatas.length > 0) {
            let campaignIntervalCapsData = state.campaignIntervalCapsData;
            for(let i = 0; i < modifiedScheduledDatas.length; i++) {
                let scheduledData = modifiedScheduledDatas[i]; //[rownumber, weekday, oldvalue, capLimit]
                let editedRowIndex = scheduledData[0];
                let editedRow = campaignIntervalCapsData[editedRowIndex];
                let weekday = scheduledData[1];
                let weekdayObj = editedRow["settings"][weekday];
                let capLimit = scheduledData[3];
                commit(SCHEDULER_SOURCE_DATA_MUTATION, { capLimit, weekdayObj });
            }
       }

    },
    async [CALLATTRIBUTE_PAGE_LOAD_ACTION]({commit,dispatch }, campaignID) {
        let response = await campaignService.GetCamapignCallAttributes(campaignID);
        let scheduleData = response.data.campaignSchedule
        if (!scheduleData)
            scheduleData = loadEmptyScheduleData(campaignID);

        getScheduleData(scheduleData);
        getScheduleIntervalCaps(scheduleData);
        commit(SCHEDULER_LOAD_SCHEDULE_MUTATION, scheduleData);
        commit(SCHEDULER_CLEAR_OLD_DATA_MUTATION); //default is empty
              
        dispatch(SCHEDULER_RESET_INTERVALS_ACTION);
        dispatch(LOAD_ACTIVE_DAY_PART_INTERVAL_ACTION);
        return response.data;
    },
    async [UPDATE_CAMPAIGN_CALLATTRIBUTE_PAGE_ACTION]({ state }, payLoad) {
        let apiScheduleData = JSON.parse(JSON.stringify(state.scheduleData));
        apiScheduleData.campaignDailySchedules.map(row=>{ 
            row.campaignDayPartSchedules.map(dayPart=> {
                if(dayPart.endMinute == appConstants.FULL_DAY) {
                    dayPart.endMinute = appConstants.MID_NIGHT;
                }
            });
        });
        apiScheduleData.campaignIntervalCaps.map(row=>{ 
            if(row.endMinute == appConstants.FULL_DAY) 
                row.endMinute = appConstants.MID_NIGHT; 
        }); 
        apiScheduleData.campaignIntervalCaps = apiScheduleData.campaignIntervalCaps.filter(row=>row.status == "Active"  && row.capLimit !== "");
        // save page data
        //when subscriptionFilterTypeName = channel or client then map channelNamelist value to campaignFilterTypeInputValue
        if(payLoad.campaignFilter && payLoad.campaignFilter.campaignFilters && payLoad.campaignFilter.campaignFilters.length > 0){
            payLoad.campaignFilter.campaignFilters.forEach(element=>{
                element.subscriptionFilterTypeID = element.subscriptionFilterTypeID != '' ? parseInt(element.subscriptionFilterTypeID) : 0;
            var result = getFilterInputNames(element);
            if(result != "")
                element.campaignFilterTypeInputValue = result;
            });
        }
        if(payLoad.campaignSchedule && payLoad.campaignSchedule.tazClientAuditLog)
            apiScheduleData.tazClientAuditLog = JSON.parse(JSON.stringify(payLoad.campaignSchedule.tazClientAuditLog));
        
        payLoad.campaignSchedule = apiScheduleData;
       
        var response = await campaignService.UpdateCamapignCallAttributes(payLoad);
        return response.data;
    },
    [SCHEDULER_ADD_REMOVE_INTERVALS_ACTION]({ commit }, payLoad) {
        commit(SCHEDULER_REMOVE_INTERVALS_MUTATION, payLoad);
        commit(SCHEDULER_ADD_INTERVALS_MUTATION, generateDayPartIntervalCells(payLoad));
    },
    [SCHEDULER_STATUS_CHANGED_ACTION]({ commit }, payLoad) {
        commit(SCHEDULER_WEEKDAY_STATUS_CHANGED_MUTATION, payLoad);
        commit(SCHEDULER_DAY_PART_STATUS_CHANGED_MUTATION, payLoad);
        commit(SCHEDULER_INTERVAL_STATUS_CHANGED_MUTATION, payLoad);
    },
    [SCHEDULER_ADD_DAY_PART_AND_INTERVALS_ACTION]({ commit }, payLoad) {
        commit(SCHEDULER_ADD_DAY_PART_MUTATION, payLoad);
        let payLoadObj = JSON.parse(JSON.stringify(payLoad));
        payLoadObj.campaignDayPart = payLoad.campaignDayPartSchedules[payLoad.campaignDayPartSchedules.length - 1];
        commit(SCHEDULER_ADD_INTERVALS_MUTATION, generateDayPartIntervalCells(payLoadObj));
    },
    [SCHEDULER_REMOVE_DAY_PART_AND_INTERVALS_ACTION]({ state, commit }, payLoad) {
        commit(SCHEDULER_REMOVE_INTERVALS_MUTATION, payLoad);
        commit(SCHEDULER_REMOVE_DAY_PART_MUTATION, payLoad);
        let scheduleData = state.scheduleData;
        getScheduleIntervalCaps(scheduleData);
        commit(SCHEDULER_LOAD_SCHEDULE_MUTATION, scheduleData);
    },
    [SCHEDULER_USE_INTERVALS_CHANGED_ACTION]({ commit,dispatch }, useIntervals) {
        commit(SCHEDULER_CHANGE_INTERVAL_LOADING_MUTATION, true);
        commit(SCHEDULER_USE_INTERVALS_CHANGED_MUTATION, useIntervals);
        commit(SCHEDULER_CLEAR_INTERVAL_CAPS_MUTATION);
        dispatch(SCHEDULER_RESET_INTERVALS_ACTION);
        commit(SCHEDULER_CHANGE_INTERVAL_LOADING_MUTATION, false);
    },
    [SCHEDULER_RESET_INTERVALS_ACTION]({ state, commit }) {
        let intervals = [];
        let useIntervals = String(state.scheduleData.useIntervals);
        for (let index = 0; index < state.scheduleData.campaignDailySchedules.length; index++) {
            let campaignDailySchedule = state.scheduleData.campaignDailySchedules[index];
            let filterInterval = state.scheduleData.campaignIntervalCaps.filter(row=>row.dayOfWeek == campaignDailySchedule.dayOfWeek);
            if(!(filterInterval && filterInterval.length > 0)) {
                for (let row = 0; row < campaignDailySchedule.campaignDayPartSchedules.length; row++) {
                    let campaignDayPart = campaignDailySchedule.campaignDayPartSchedules[row];
                    intervals = intervals.concat(generateDayPartIntervalCells({
                        campaignDayPart: campaignDayPart,
                        dayOfWeek: campaignDailySchedule.dayOfWeek,                       
                        dayPartItemIndex: row,
                        status: (campaignDailySchedule.status == 'Active' && useIntervals == "true") ? 'Active' : 'InActive',
                    }));
                }
            }
        }
        commit(SCHEDULER_ADD_INTERVALS_MUTATION, intervals);
    },
    [LOAD_ACTIVE_DAY_PART_INTERVAL_ACTION]({state,commit}){
        var activeDailySchedule = state.scheduleData.campaignDailySchedules.filter(row => row.status == "Active")
        let activeDayPartIntervals = [];
        for(var i = 0; i < activeDailySchedule.length; i++ ){
            let campaignDailySchedule = activeDailySchedule[i];
            for(var row = 0; row < campaignDailySchedule.campaignDayPartSchedules.length; row++){
                let campaignDayPart = campaignDailySchedule.campaignDayPartSchedules[row];
                activeDayPartIntervals = activeDayPartIntervals.concat(generateDayPartIntervalCells({
                    campaignDayPart: campaignDayPart,
                    dayOfWeek: campaignDailySchedule.dayOfWeek,                       
                    dayPartItemIndex: row,
                    status: campaignDailySchedule.status
                }));
            }
        }
        commit(LOAD_ACTIVE_DAY_PART_INTERVAL_MUTATION, activeDayPartIntervals);

    },
    [SCHEDULER_INTERVAL_SETTING_CHANGED_ACTION]({ commit, dispatch }, intervalSetting) {
        commit(SCHEDULER_CHANGE_INTERVAL_LOADING_MUTATION, true);
        commit(SCHEDULER_INTERVAL_SETTING_CHANGED_MUTATION, intervalSetting);
        commit(SCHEDULER_CLEAR_INTERVAL_CAPS_MUTATION);
        dispatch(SCHEDULER_RESET_INTERVALS_ACTION);
        commit(SCHEDULER_CHANGE_INTERVAL_LOADING_MUTATION, false);
    },
   
    [SCHEDULET_GET_INTERVAL_ACTION]({ commit,state}){
        if(state.isIntervalModified){
            var campaignDailySchedules = state.scheduleData.campaignDailySchedules.filter(row=>row.status == "Active")
            var campaignDailyScheduleData = campaignDailySchedules.map(r => r.campaignDayPartSchedules.map(row =>row.endMinute - row.startMinute))
            var minInterval = 0;

            if(campaignDailyScheduleData.length > 0){
                minInterval = Math.min(...[].concat(...campaignDailyScheduleData));
            }
            var intervalData =  updateIntervalData(state.intervalData,minInterval);
            commit(SCHEDULER_UPDATE_INTERVAL_DATA_MUTATION,intervalData)
        }
        else
            commit(SCHEDULER_UPDATE_INTERVAL_DATA_MUTATION,state.intervalData)

    }
};

function getScheduleData(scheduleData) {
    for (let index = 1; index <= 7; index++) {
        let dayOfWeek = ((index == 7) ? 0 : index); // '0' is used for sunday this condition is used.
        if (scheduleData && scheduleData.campaignDailySchedules && scheduleData.campaignDailySchedules.length > 0) {
            var findInactiveIndex = scheduleData.campaignDailySchedules.findIndex(row => row.dayOfWeek == dayOfWeek && row.status == "InActive");
            if(findInactiveIndex != -1)
            {
            scheduleData.campaignDailySchedules[findInactiveIndex].campaignDayPartSchedules = [];
            scheduleData.campaignDailySchedules[findInactiveIndex].campaignDayPartSchedules.push({
                scheduleCapID: 0,
                capLimit: "",
                concurrencyCap: "",
                startMinute: 0,
                endMinute: 1439,
                status: "InActive"
            });
            }
            if(!scheduleData.campaignDailySchedules.some(row => row.dayOfWeek == dayOfWeek))
                scheduleData.campaignDailySchedules.push({ dayOfWeek: dayOfWeek, status: 'Active', campaignDayPartSchedules: [getEmptyDayPart()] });
        } else
            scheduleData.campaignDailySchedules.push({ dayOfWeek: dayOfWeek, status: 'Active', campaignDayPartSchedules: [getEmptyDayPart()] });
    }
    scheduleData.campaignDailySchedules.map(row => {
        row.campaignDayPartSchedules.map(dayPart => {
            if(dayPart.endMinute == appConstants.MID_NIGHT) {
               dayPart.endMinute = appConstants.FULL_DAY;
            }
        });
    });
}

function getScheduleIntervalCaps(scheduleData) {
    if (scheduleData && scheduleData.campaignIntervalCaps) {
        if(scheduleData.campaignIntervalCaps.length > 0){
            var data = scheduleData.campaignIntervalCaps.filter(row=>row.status == "Active");
            var maxIntervalMinute = Math.min(...data.map(row=>row.endMinute-row.startMinute));
            scheduleData.intervalSetting = maxIntervalMinute >= 45 ? 60 : maxIntervalMinute < 15 ? 15 : maxIntervalMinute ;
        }
        let campaignDailySchedule = scheduleData.campaignDailySchedules;
        for (let index = 0; index < campaignDailySchedule.length; index++) {
            let dayOfWeek = campaignDailySchedule[index].dayOfWeek;
            let status = campaignDailySchedule[index].status;
            let campaignDayPartSchedules = campaignDailySchedule[index].campaignDayPartSchedules;
            for (let dayPartIndex = 0; dayPartIndex < campaignDayPartSchedules.length; dayPartIndex++) {
                let campaignDayPart = campaignDayPartSchedules[dayPartIndex];
                let filteredValue = scheduleData.campaignIntervalCaps.filter(row => row.dayOfWeek == dayOfWeek && 
                    parseInt(row.startMinute) >= parseInt(campaignDayPart.startMinute) && 
                    parseInt(row.endMinute) <= parseInt(campaignDayPart.endMinute)).concat([]);
                filteredValue.map(row => { 
                    row.dayPartItemIndex = dayPartIndex;
                    row.status = (status == 'Active' && String(scheduleData.useIntervals)=="true") ? 'Active' : 'InActive';
                    row.capLimit = row.status == 'Active' ? row.capLimit : '';
                });
            }
        }
    }
    scheduleData.campaignIntervalCaps.map(row => { if(row.endMinute == appConstants.MID_NIGHT) row.endMinute =  appConstants.FULL_DAY; });
}

function getEmptyDayPart(previousDayPart) {
     //0 = 12 AM, 1020 = 5 PM, 1425 = 11.45 PM, 1439 = midnight
    let startMinute = 0;
    let endMinute = 1439;
    if (previousDayPart) {
        if (parseInt(previousDayPart.endMinute) >= appConstants.FULL_DAY) {
            startMinute = 1425;
            endMinute = appConstants.FULL_DAY;
        } else {
            startMinute = previousDayPart.endMinute;
            endMinute = parseInt(previousDayPart.endMinute) + 15;
        }
    }
    return {
        scheduleCapID: 0,
        capLimit: "",
        concurrencyCap: "",
        startMinute: startMinute,
        endMinute: endMinute,
        status: "Active",
    };
}

function loadEmptyScheduleData(campaignID) {
    return {
        campaignID: campaignID,
        monthlyCap: '',
        useIntervals: false,
        intervalSetting: 15,
        campaignDailySchedules: [],
        campaignIntervalCaps: [],
    };
}
function generateDayPartIntervalCells(payLoad) {
    var intervalDropDownData = state.intervalData.filter(x=>!x.isDisabled && x.isSelected);
    var selectedIntervalSetting = intervalDropDownData.length > 0 ? intervalDropDownData[0].defaultIntervalValue : state.scheduleData.intervalSetting;
    var findRemainingMinutes = payLoad.campaignDayPart.startMinute % selectedIntervalSetting
    var setStartMinute = payLoad.campaignDayPart.startMinute - findRemainingMinutes;
    var minutes = payLoad.campaignDayPart.endMinute - setStartMinute;
    var numberOfIntervals = minutes / selectedIntervalSetting;
    var interval = [];
    let useIntervals = String(state.scheduleData.useIntervals);
    for (var i = 0; i < numberOfIntervals; i++) {
        var intervalSetting = parseInt(selectedIntervalSetting);
        let endMinute = (parseInt(setStartMinute) + (i * intervalSetting)) + intervalSetting;
        let startMinute = i == 0 ? payLoad.campaignDayPart.startMinute: setStartMinute;
        interval.push({
            dayPartItemIndex: payLoad.dayPartItemIndex,
            capLimit: "",
            capCounter: 0,
            dayOfWeek: payLoad.dayOfWeek,
            startMinute: parseInt(startMinute) + (i * intervalSetting),
            endMinute: (endMinute > payLoad.campaignDayPart.endMinute) ? payLoad.campaignDayPart.endMinute : endMinute,
            status: (useIntervals == "true" && payLoad.status == 'Active') ? 'Active' : 'InActive',
        });
    }
    return interval;
}
function updateIntervalData(intervalData,minInterval){
    var filterIntervalData = (state.scheduleData.campaignIntervalCaps && state.scheduleData.campaignIntervalCaps.length > 0)? state.scheduleData.campaignIntervalCaps.filter(row=> row.status == "Active") : [];
            var filterdIntervalCaps = filterIntervalData.map(row =>row.endMinute - row.startMinute);
            var selectedInterval = 15;
            if(filterdIntervalCaps.length > 0){
                selectedInterval = Math.min(...[].concat(...filterdIntervalCaps));
            }
    if((minInterval % 60) == 0 || minInterval == 45){
        intervalData.forEach(element => {
            element.isDisabled = false;
           var minutes  = (element.defaultIntervalValue == selectedInterval && selectedInterval > 45) ? 60 : selectedInterval;
           element.isSelected = (element.defaultIntervalValue == minutes && minutes > 45) ? true : false ;
        });
        return intervalData;
    }
    if((minInterval % 30) == 0){
        intervalData.forEach(element => {
            element.isDisabled = (element.defaultIntervalValue == 60) ? true : false;
            var minutes = (element.defaultIntervalValue == selectedInterval && selectedInterval < 45 && selectedInterval > 15 ) ? 30 : selectedInterval
            minutes = (minutes != 30 && minutes != 15) ? 15 : minutes;
            element.isSelected = (element.defaultIntervalValue == minutes ) ? true : false ;
      
        });
        return intervalData;
    }
    if((minInterval % 15) == 0){
        intervalData.forEach(element => {
            element.isDisabled = (element.defaultIntervalValue == 15) ? false : true;
            element.isSelected = (element.defaultIntervalValue == 15) ? true : false ;
       
        });
    }
    return intervalData
}

function getFilterInputNames(payLoad){
    var result = [];
    if(payLoad.subscriptionFilterTypeID == 40){
       payLoad.selectedFilterNameList.filter(x=>x.isCheckedChannel).map(m=> {result.push(m.clientQuoteTypeID) });
    }
    if(payLoad.subscriptionFilterTypeID == 41){
      payLoad.selectedFilterNameList.filter(x=>x.clientID).map(m=> {result.push(m.clientID) });
    }
    result = result.join(",");
    return result;
  }

